import React from "react";
import { Box } from "..";
import { useStyles } from "./Flag.styles";
import { FlagProps } from "./Flag.types";

function Flag(props: FlagProps) {
  const classes = useStyles(props);
  return <Box {...props} className={classes.root} />;
}

export default Flag;
